//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';

export const getPostPreviewLinkMetadata = createSelector(
  (state: ICuralateStore) => state.twitter.postDetails.linkPostPreviewData,
  (linkPostPreviewData) => linkPostPreviewData?.linkMetadata,
);

export const getPostPreviewUrl = createSelector(
  (state: ICuralateStore) => state.twitter.postDetails.linkPostPreviewData,
  (linkPostPreviewData) => linkPostPreviewData?.url,
);
